import { createContext, useContext } from 'react';
import { Tier } from '../constants/tier';

export interface Organization {
  id: number;
  name: string;
  tier: Tier;
}

export type UserWorkspace = Organization & { isDefault: boolean };

interface WorkspaceContextType {
  currentWorkspace: Organization | null;
  availableWorkspaces: Organization[];
  switchWorkspace: (orgId: number) => void;
  isLoadingWorkspaces: boolean;
  canSwitchWorkspaces: boolean;
}

export const WorkspaceContext = createContext<WorkspaceContextType>({
  currentWorkspace: null,
  availableWorkspaces: [],
  switchWorkspace: () => {},
  isLoadingWorkspaces: true,
  canSwitchWorkspaces: false,
});

export const useWorkspace = () => {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }
  return context;
};
